document.addEventListener('DOMContentLoaded', function () {
  const giftCardSection = document.getElementById('gift-card-section');
  const giftCardCheckbox = document.getElementById('gift-card-checkbox');
  const giftCardDetails = document.getElementById('gift-card-details');
  const giftCardMessage = document.getElementById('gift-card-message');
  const addGiftCardBtn = document.getElementById('add-gift-card-btn');
  const giftCardProductId = window.giftcard; // 45884493103340// ID del producto para la tarjeta de regalo.

  // Verificar si el producto de tarjeta de regalo ya está en el carrito.
  function checkIfCardExists() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const productInCart = cart.items.some(item => item.id === giftCardProductId);
        if (!productInCart) {
          giftCardSection.style.display = 'block';
        }
      });
  }

  checkIfCardExists();


  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart-remove-button') 
      || event.target.classList.contains('quantity__button')
      || event.target.tagName.toLowerCase() === 'path'
      || event.target.tagName.toLowerCase() === 'svg') {
      setTimeout(function() {
        checkIfCardExists();
      }, 1000);
    } else {
    }
  });

  // Manejar el cambio en el checkbox.
  giftCardCheckbox.addEventListener('change', function () {
    if (this.checked) {
      giftCardDetails.style.display = 'block';
    } else {
      giftCardDetails.style.display = 'none';
      giftCardMessage.value = '';
      addGiftCardBtn.disabled = true;
    }
  });

  // Habilitar/deshabilitar el botón si el textarea tiene contenido.
  giftCardMessage.addEventListener('input', function () {
    addGiftCardBtn.disabled = !giftCardMessage.value.trim();
  });

  // Manejar la adición del producto de tarjeta de regalo al carrito.
  addGiftCardBtn.addEventListener('click', function () {
    if (!giftCardMessage.value.trim()) {
      //alert('Por favor, ingrese un mensaje para la tarjeta de regalo.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: giftCardProductId,
        quantity: 1,
        properties: {
          'Mensaje de tarjeta': giftCardMessage.value
        }
      }),
    })
    .then(response => response.json())
    .then(() => {
      //alert('Tarjeta de regalo agregada al carrito.');
      location.reload(); // Refrescar la página para actualizar el carrito.
    })
    .catch(error => {
      console.error('Error al agregar la tarjeta de regalo:', error);
      //alert('Hubo un error al agregar la tarjeta de regalo.');
    });
  });
});
